var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard" },
    [
      _vm.doctor
        ? _c("div", [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "columns" }, [
                _c(
                  "div",
                  { staticClass: "column is-3" },
                  [_c("app-sidebar"), _vm._v(" "), _c("onboarding")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "column is-9" },
                  _vm._l(_vm.offices, function(office) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: office.id == _vm.currentOffice,
                            expression: "office.id == currentOffice"
                          }
                        ],
                        staticClass: "mt-7"
                      },
                      [
                        _c("div", { staticClass: "tabs" }, [
                          _c(
                            "ul",
                            _vm._l(_vm.dates, function(date) {
                              return _c(
                                "li",
                                {
                                  class: {
                                    "is-active": date == _vm.currentDate
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.selectDate(date)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("momentFormat")(
                                            date,
                                            "YYYY-MM-DD",
                                            _vm.$t("date_selector_format")
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "columns" }, [
                          _c("div", { staticClass: "column is-6" }, [
                            _c("nav", { staticClass: "panel" }, [
                              _c("p", { staticClass: "panel-heading" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("next_appointments_section_title")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "panel-block p-0" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table is-fullwidth is-striped mb-0"
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "next_appointments_table_details_header"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("th")
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      [
                                        _vm._l(
                                          _vm.officeReservedAvailabilities,
                                          function(availability) {
                                            return _c("tr", [
                                              _c("td", [
                                                _vm.hasAvailabilityPictures(
                                                  availability
                                                )
                                                  ? _c(
                                                      "figure",
                                                      {
                                                        staticClass:
                                                          "image thumbnail is-32x32 is-inline-block is-pulled-left m-1 mr-2 clickable",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.showEmergency(
                                                              availability
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticStyle: {
                                                            "max-height":
                                                              "100%",
                                                            "max-width": "100%"
                                                          },
                                                          attrs: {
                                                            src: _vm.getAvailabilityPicture(
                                                              availability
                                                            ),
                                                            alt: "Image Preview"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "button is-info is-outline is-pulled-left mr-2",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.showEmergency(
                                                              availability
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("b-icon", {
                                                          attrs: {
                                                            icon:
                                                              "clipboard-account"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "data-title" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                            " +
                                                        _vm._s(
                                                          availability.start
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          availability.end
                                                        ) +
                                                        "\n                                                            "
                                                    ),
                                                    _c("span", {
                                                      staticClass:
                                                        "is-size-7 has-text-grey has-text-weight-light",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.getAvailabilityStatus(
                                                            availability
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "data-value",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.getPatientInfo(
                                                        availability
                                                      )
                                                    )
                                                  }
                                                })
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "has-text-right",
                                                  attrs: { width: "105px" }
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "button is-danger",
                                                      attrs: {
                                                        disabled:
                                                          availability.appointmentId
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.cancelInvitation(
                                                            availability.appointmentInvitationId
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("b-icon", {
                                                        attrs: {
                                                          icon: "delete-forever"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ])
                                          }
                                        ),
                                        _vm._v(" "),
                                        Object.keys(
                                          _vm.officeReservedAvailabilities
                                        ).length == 0
                                          ? _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "has-text-centered has-text-grey",
                                                  attrs: { colspan: "2" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "next_appointments_section_empty_placeholder"
                                                        )
                                                      ) +
                                                      "\n                                                    "
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column is-6" }, [
                            _c("nav", { staticClass: "panel" }, [
                              _c("p", { staticClass: "panel-heading" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("next_availabilities_section_title")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "panel-block p-0" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table is-fullwidth is-striped mb-0"
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "next_availabilities_table_details_header"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      [
                                        _vm._l(
                                          _vm.officeAvailabilities,
                                          function(availability) {
                                            return _c("tr", [
                                              _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button is-info is-outline is-pulled-left mr-2",
                                                    attrs: { disabled: "" }
                                                  },
                                                  [
                                                    _c("b-icon", {
                                                      attrs: {
                                                        icon:
                                                          "clipboard-account"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "data-title" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        availability.start
                                                      ) +
                                                        " - " +
                                                        _vm._s(availability.end)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "data-value" },
                                                  [_vm._v("—")]
                                                )
                                              ])
                                            ])
                                          }
                                        ),
                                        _vm._v(" "),
                                        Object.keys(_vm.officeAvailabilities)
                                          .length == 0
                                          ? _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "has-text-centered has-text-grey"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "next_availabilities_section_empty_placeholder"
                                                        )
                                                      ) +
                                                      "\n                                                    "
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      Object.keys(_vm.currentEmergency).length > 0
        ? _c("emergency-modal", {
            attrs: {
              active: _vm.showEmergencyModal,
              emergency: _vm.currentEmergency,
              availability: _vm.currentAvailability
            },
            on: {
              close: function($event) {
                return _vm.closeEmergencyModal()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bcf6bb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bcf6bb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/Dashboard.vue
// module id = 627
// module chunks = 1